import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVerticalAlignCenterComponent } from "./med-icon-vertical-align-center.component";

@NgModule({
  declarations: [
    MedIconVerticalAlignCenterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVerticalAlignCenterComponent,
  ],
})
export class MedIconVerticalAlignCenterModule { }
